import apiSlice from "./ApiSlice";

export const registrationLinkApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // ADD
    addRegistrationLink: builder.mutation({
      invalidatesTags: ["registration-link"],
      query: (body) => {
        return {
          url: "/registration-link/add",
          method: "POST",
          body,
        };
      },
    }),
    //Get All
    getAllRegistrationLink: builder.query({
      providesTags: ["registration-link"],
      query: (body) => {
        return {
          url: "/registration-link",
          method: "POST",
          body,
        };
      },
    }),

     // Change Status
     changeStatus: builder.mutation({
        invalidatesTags: ["registration-link"],
        query: (id) => {
          return {
            url: `/registration-link/status-change/${id}`,
            method: "PUT",
           
          };
        },
      }),

     
  }),
});

export const {
  useAddRegistrationLinkMutation,
  useGetAllRegistrationLinkQuery,
  useChangeStatusMutation
} = registrationLinkApi;
